const ChurchCenterRegistrationsShow = {
  init() {
    this.discountToggle()
    return $(".delete-attendee-js").on("click", this.handleRemoveAttendee)
  },

  discountToggle() {
    let $toggler = $(".js-discount-toggle")
    let $togglee = $(".js-discount-section")
    $toggler.off("click")
    return $toggler.on("click", () => {
      $togglee.toggleClass("d-n")
      $toggler.toggleClass("d-n")
    })
  },

  handleRemoveAttendee(e) {
    const attendeeUrl = $(e.target)
      .closest(".delete-attendee-js")
      .data("attendee-url")
    const redirectUrl = $(e.target)
      .closest(".delete-attendee-js")
      .data("redirect-url")
    return alertModal(
      {
        title: "Remove Attendee?",
        text: "Any payments will not be automatically refunded.",
        type: "warning",
        showCancelButton: true,
        cancelButtonText: "No, don't delete",
        confirmButtonText: "Yes, delete attendee!",
        customClass: "destructive-warning"
      },
      () =>
        $.ajax({
          method: "POST",
          headers: { "X-CSRF-Token": Rails.csrfToken() },
          url: attendeeUrl,
          data: { _method: "delete" },
          dataType: "script",
          success() {
            return window.location.replace(redirectUrl)
          }
        })
    )
  },
  initialize() {
    $(document).on("turbolinks:load", () => this.init())
  }
}

export default ChurchCenterRegistrationsShow
